var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-icon"},[(!_vm.alignRight)?_c('BaseImage',{class:['icon', _vm.size],attrs:{"url":_vm.iconUrl}}):_vm._e(),_vm._t("default"),(_vm.alignRight)?_c('BaseImage',{class:['icon', 'icon--right', _vm.size],attrs:{"url":_vm.iconUrl}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }